import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 職業一覧API
 */
export const listJobs = (params = {}) => {
  const defaults = {
    _path: 'IQ/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 住所取得API
 */
export const listAddresses = (params = {}) => {
  const defaults = {
    _path: 'IQ/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 選択パッケージ＆ライセンス情報一覧API
 */
export const listPackageAndLicenses = (params = {}) => {
  const defaults = {
    _path: 'IQ/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 無料トライアルメール登録API
 */
export const registerFreeTrial = (params = {}) => {
  const defaults = {
    _path: 'IQ/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 無料トライアル・見積り＆お問い合わせ登録API
 */
export const registerTrialEstimateInquiry = (params = {}) => {
  const defaults = {
    _path: 'IQ/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * お問い合わせ登録API
 */
export const registerInquiry = (params = {}) => {
  const defaults = {
    _path: 'IQ/006',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * お見積もり登録API
 */
export const registerEstimate = (params = {}) => {
  const defaults = {
    _path: 'IQ/007',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * お見積もり内容確認API
 */
export const confirmEstimate = (params = {}) => {
  const defaults = {
    _path: 'IQ/008',
    token: store.state.auth.token
  }

  // paramsにtokenが設定されている場合は、その値がtokenとして優先される
  // (メールのURLからアクセスした場合のトークン認証時)
  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 顧客基本情報文字エンコーディングチェックAPI
 */
export const checkEncoding = (params = {}) => {
  const defaults = {
    _path: 'IQ/009',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 新規契約申込完了API
 */
export const completeNewApplication = (params = {}) => {
  const defaults = {
    _path: 'IQ/010',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}


/**
 * 新規契約申込完了API（LCログイン後）
 */
export const completeLoggedinNewApplication = (params = {}) => {
  const defaults = {
    _path: 'IQ/011',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }
  // return new Promise((resolve) => {
  //   const response = {
  //     data: {
  //       status: 0,
  //       error_message: ''
  //     }
  //   }
  //   resolve(response)
  // })
  return axios.post(API_RELAY_PATH, r)
}
